<style lang="scss">
    .inline-autocomplete {
        .autocomplete {
            padding: 0;
        }
        input {
            border: thin solid #666;
            /*font-size: 1.2em;*/
            border-radius: 3px;
            padding: 18px !important;
            padding-left: 16px !important;
            background-color: #fff;
            background-image: none;
            /*padding-left: 50px !important;*/
        }
    }
</style>

<template>
    <form autocomplete="off" @submit.prevent="() => {}">
        <input autocomplete="false" name="hidden" type="text" style="display:none;">
        <input type="text" name="address" id="address_fake" autocomplete="off" style="display:none">
        <input type="text" name="address" id="address" autocomplete="off" style="display: none;" placeholder="Address" />
        <autocomplete
                :placeholder="'Street Address'"
                ref="addressAutocomplete"
                class="inline-autocomplete"
                :search="search"
                :aria-disabled="disabled"
                :disabled="disabled"
                :debounce-time="500"
                :get-result-value="getAddressValue"
                autocomplete="off"
                @submit="setAddress"
        >
            <template #result="{ result, props }">
                <li v-bind="props">
                    {{ result.description }}
                </li>
            </template>
        </autocomplete>
    </form>
</template>

<script>
    import ValidatedSection from "./ValidatedSection";
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import {mapState} from "vuex";
    import googleMapsLoader from "../../../utils/googleMapsLoader";
    
    export default {
        name: "AutocompletedAddressForm",
        components: {ValidatedSection, Autocomplete},
        props: ['states', 'counties', 'disabled', 'initialAddress'],
        data() {
            return {
                propertyAddress: {
                    line_1: '',
                    line_2: '',
                    city: '',
                    county_id: null,
                    state_id: null,
                    zip: '',
                },
                googleMapsLoader: googleMapsLoader,
            }
        },
        computed: {
            countiesForState() {
                if(!this.propertyAddress.state_id) return [];

                return _.filter(this.counties, county => county.state_id === this.propertyAddress.state_id);
            },
            ...mapState('Prequalification', {
                apiKey: state => state.googleApiKey,
            })
        },
        async mounted() {
          if(this.initialAddress) {
            this.setLine1(this.initialAddress);
          }
          
          // Initialize Google Maps Places library
          try {
              await this.googleMapsLoader.loadPlacesLibrary();
          } catch (error) {
              console.error('Failed to load Google Maps Places library:', error);
          }
        },
        methods: {
            async search(term) {
                this.$emit('input', term);
                if(term.length < 2) return [];
                return await this.getGoogleResults(term);
            },
            setLine1(line1) {
                this.$refs.addressAutocomplete.value = line1;
            },
            async getGoogleResults(term) {
                try {
                    // Ensure the library is loaded before making predictions
                    const library = await this.googleMapsLoader.loadPlacesLibrary();
                    if (!library || !library.AutocompleteService) {
                        console.warn('Google Places library not available');
                        return [];
                    }
                    
                    return await this.googleMapsLoader.getPlacePredictions(term, {
                        types: ['address']
                    });
                } catch (error) {
                    console.error('Error getting place predictions:', error);
                    return [];
                }
            },
            getAddressValue(result) {
                return result.description;
            },
            async setAddress(result) {
                try {
                    // Get Place Details using new API
                    const place = await this.googleMapsLoader.getPlaceDetails(result.place_id, [
                        'displayName', 
                        'location', 
                        'addressComponents'
                    ]);

                    let numberComponent = this.getPlaceComponentByType(place, 'street_number');
                    let streetComponent = this.getPlaceComponentByType(place, 'route');
                    let cityComponent = this.getPlaceComponentByType(place, 'locality');
                    let countyNameComponent = this.getPlaceComponentByType(place, "administrative_area_level_2");
                    let stateAbbrComponent = this.getPlaceComponentByType(place, 'administrative_area_level_1');
                    let zipComponent = this.getPlaceComponentByType(place, 'postal_code');

                    let number = numberComponent ? numberComponent.long_name : '';
                    let street = streetComponent ? streetComponent.short_name : '';
                    let city = cityComponent ? cityComponent.long_name : '';
                    let countyName = countyNameComponent ? countyNameComponent.long_name : '';
                    let stateAbbr = stateAbbrComponent ? stateAbbrComponent.short_name : '';
                    let zip = zipComponent ? zipComponent.short_name : '';

                    this.$refs.addressAutocomplete.value = number + ' ' + street;
                    this.propertyAddress.line_1 = number + ' ' + street;
                    this.propertyAddress.city = city;
                    this.propertyAddress.zip = zip;
                    this.propertyAddress.state_id = this.getStateIdFromAbbr(stateAbbr);
                    this.propertyAddress.county_id = this.getCountyIdFromName(countyName);
                    this.$emit('updated', this.propertyAddress);
                } catch (error) {
                    console.error('Error getting place details:', error);
                }
            },
            getStateIdFromAbbr(stateAbbr) {
                for(var i in this.states) {
                    if(this.states[i].state_acronym === stateAbbr) {
                        return this.states[i].id;
                    }
                }
            },

            getCountyIdFromName(countyName) {
                for(var i in this.countiesForState) {
                    let county = this.countiesForState[i];
                    if(county.county_name === countyName) {
                        return county.id;
                    }
                    let shortName = countyName.replace(' County', '');
                    if(county.county_name === shortName) {
                        return county.id;
                    }
                }
            },
            getPlaceComponentByType(place, type) {
                // Handle new Google Places API structure
                const addressComponents = place.addressComponents || place.address_components;
                
                for(var i in addressComponents) {
                    const component = addressComponents[i];
                    // New API structure uses Dg for types array
                    const types = component.Dg || component.types;
                    
                    if(types && types.includes(type)) {
                        // Return component with standardized structure
                        return {
                            long_name: component.Eg || component.long_name,
                            short_name: component.Fg || component.short_name,
                            types: types
                        };
                    }
                }
            },
        }
    }
</script>
